import './Simulacao.css';
import { useState } from 'react';
import { useCookies } from "react-cookie";
import { HiOutlineLockClosed } from "react-icons/hi";
import { useNavigate } from 'react-router-dom'
import EtapaSimulacao from '../../../components/Banners/EtapaSimulacao/EtapaSimulacao'
import BannerHomePhone from '../../../components/Banners/BannerHomePhone/BannerHomePhone.js'
import OutrasOpcoes from '../../../components/OutrasOpcoes/OutrasOpcoes'
import BannerSimulacaoPhone from '../../../components/Banners/BannerSimulacaoPhone/BannerSimulacaoPhone'
import Button from '../../../components/Button/button';
import axios from 'axios';
import api from '../../../services/api.js';
import Loading from '../../Loading/Loading.js'
import Input from '../../../components/Input/input';

function Simulacao() {
    const [callListarOferta, setCallListarOferta] = useState(true);
    const [exibirPagina, setExibirPagina] = useState(false);
    const [exibirPropostas, setExibirPropostas] = useState(true);
    const [debubJson, setDebubJson] = useState("");
    const showProposta = () => {
        setIsOpen((isOpen) => !isOpen);
    };

    const choicePropos = () => {
        setIsOpen(false)
    }

    const [isOpen, setIsOpen] = useState(false);
    const [cookies] = useCookies(['__gtm_campaign_url']);
    const [fieldsValidity, setFieldsValidity] = useState([]); // Inicializa o array de erros
    const [isChecked, setIsChecked] = useState(true)
    const [payload, setPayload] = useState([]);
    const navigate = useNavigate();
    const [isShow, setShow] = useState(true);
    const encode_data = sessionStorage.getItem("encode_data")
    const [outrasPropostas, setOutrasPropostas] = useState([]);
    
    
    const [valorTotalProposta, setValorTotalProposta] = useState('');
    const [valor, setValor] = useState('');
    const [prazo, setPrazo] = useState('');

    // INICIO: Carrega ofertas

    if (callListarOferta){ 
        api.put(`/crefaz/listarOfertas/${encode_data}`, {})
        .then((response) => {

            if(response.data.cod_erro == null) {    
                window.dataLayer.push({ "event": "'endereco-valido" });
            }

            
            setCallListarOferta(false);
            // console.log("Response Proposta", response.data);
            if(response.data.cod_erro == 1) {  
                window.location.href = 'https://euquerograna.com.br';  
            } // Endereço sem produtos disponíveis 

            // setDebubJson(JSON.stringify(response.data));

            // console.log(response);

            // alert(response.data.cod_erro);

            if(response.data.cod_erro == 2) { 
                if (response.data.ofertas == null){
                    window.location.href = 'https://euquerograna.com.br'; 
                }else{
                    const totalValorProposta = JSON.parse(JSON.stringify(response["data"]["simulacao"]["valor_limite"]));
                    console.log(totalValorProposta);
                    const outrasPropostaResp = JSON.parse(JSON.stringify(response["data"]["simulacao"]["simulacao_resposta"]["prazoValor"]));
                    const proposta = JSON.parse(JSON.stringify(response["data"]["simulacao"]["simulacao_resposta"]["prazoValor"][0]));
                    
                    setValorTotalProposta(totalValorProposta.valorLimiteSolicitado)
                    setValor(proposta.valor);
                    setPrazo(proposta.prazo);

                    if(exibirPropostas) {
                        setOutrasPropostas(outrasPropostaResp);
                        setExibirPropostas(true);
                    }

                    setExibirPagina(true);
                    setShow(false);  
                }
            } // Cliente já possui proposta em andamento 
            else {

                if(response.data.cod_erro == 3) { 
                    navigate("/contato") 
                } else if (response.data.cod_erro == 4) { 
                    navigate("/contato") 
                } else if (response.data.cod_erro == 5) { 
                    navigate("/atencao") 
                } else if(response.data.cod_erro == 0) { 
                    navigate("/contato") 
                } else if(response.data.cod_erro == null) { 
                    setExibirPagina(true);
                    setShow(false);

                    const totalValorProposta = JSON.parse(JSON.stringify(response["data"]["simulacao"]["valor_limite"]));
                    console.log(totalValorProposta);

                    const outrasPropostaResp = JSON.parse(JSON.stringify(response["data"]["simulacao"]["simulacao_resposta"]["prazoValor"]));
                    const proposta = JSON.parse(JSON.stringify(response["data"]["simulacao"]["simulacao_resposta"]["prazoValor"][0]));
                    // const proposta = JSON.parse(JSON.stringify(response["data"]["select_prestacao"]));
                    // console.log("listarOfertas", proposta)
                    
                    setValorTotalProposta(totalValorProposta.valorLimiteSolicitado)
                    setValor(proposta.valor);
                    setPrazo(proposta.prazo);

                    if(exibirPropostas) {
                        setOutrasPropostas(outrasPropostaResp);
                        setExibirPropostas(false);
                    }

                    setShow(false);

                    
                } else {
                    navigate("/contato") 
                } // Tela de que um consultor entrará em contato
            }
        })
        .catch((err) => {
            setCallListarOferta(false);
            console.log(err);
            setShow(false);
            navigate("/contato");
        })   
        // FINAL: Carrega ofertas
    }

    function convertCookie(cookieUrl) {
        const rawParams = cookieUrl?.split("?")?.[1]?.split("&");
        const wantedParams = [
            "utm_source",
            "utm_medium",
            "utm_campaign",
            "utm_id",
            "utm_content",
            "utm_term",
            "gclid",
            "fbclid",
            "aff_click_id",
        ];

        const cleanParams = {}

        if (rawParams) {
            for (const rawParam of rawParams) {

                const [key, value] = rawParam.split("=");

                // eslint-disable-next-line eqeqeq
                if (key == 'aff_click_id') {
                    axios.get(`https://api.vsboon.com.br/reward/delivery/savvi?aff_click_id=${value}&action_type=Inapp`)
                        .then(() => {
                            //   console.log('deu certo')
                        })
                        .catch(() => {
                            //   console.log('deu errado')
                        })
                }
                if (key && value && wantedParams.includes(key)) {

                    cleanParams[key] = value;
                }
            }
            return cleanParams;
        }

        return {};
    }


    let buttonContinuar = document.querySelector(".btnContinuar");
    let buttonVoltar = document.querySelector(".btnVoltar");
    let btnContinuar = "btnContinuar"
    let btnVoltar = "btnVoltar"

    async function handleSubmit(e) {
        e.preventDefault();
        const errors = handleOnBlur(payload, "submit");

        if (errors.length === 0) {
            const cookieParams = convertCookie(cookies.__gtm_campaign_url);
            const sendbackend = {
                utm_campaign: (cookieParams.utm_campaign || ""),
                utm_medium: (cookieParams.utm_medium || ""),
                utm_source: (cookieParams.utm_source || ""),
                utm_id: (cookieParams.utm_id || ""),
                utm_content: (cookieParams.utm_content || ""),
                utm_term: (cookieParams.utm_term || ""),
                gclid: (cookieParams.gclid || ""),
                fbclid: (cookieParams.fbclid || ""),
                aff_click_id: (cookieParams.aff_click_id || ""),
            }
            
            const JsonArray = JSON.stringify(sendbackend)
            // const json_obj = JSON.parse(JsonArray)

            setShow(true);

            var elParcela = document.getElementById("parcelaSimulacao");
            var elValor = document.getElementById("valorSimulacao");
            
            const select_prestacao =  {
                "select_prestacao": {
                    prazo: parseFloat(elParcela.value), 
                    valor: parseFloat(elValor.value)
                }
            }

            console.log(select_prestacao);

            api.put(`crefaz/finalizarOferta/${encode_data}`, select_prestacao, {

            })
                .then((response) => {
                    const encode = response.data.encode_data
                    const id = response.data.id
                    sessionStorage.setItem("encode_data", encode);
                    sessionStorage.setItem("id", id);

                    sessionStorage.setItem("payload_value", elValor);

                    navigate("/dados-conta")
                    setShow(false);
                })
                .catch((err) => {
                    console.log("erro", err)
                    navigate("/contato")
                    buttonContinuar.disabled = false;
                    setShow(true);
                })
        } 
    }
    const handleOnBlur = (e, prop) => {//e = valor digitado, prop =  nome do input 
        const errors = [];
       
        setFieldsValidity(errors)

        return errors;
    }

    var melhorOpcao =  `creditoAprovado ${isOpen ? 'bc-cinza' : 'bc-azul'}`;
    var melhorOpcao2 =  `bulletSel ${isOpen ? 'bc-cinza' : 'bc-azul'}`;
    var circulo =  `bulletSel2 ${isOpen ? 'bc-azul' : 'bc-cinza'}`;
    var btnOpcao =  `propostas ${isOpen ? 'bc-azul' : 'bc-cinza'}`;

    return (
        <div className="home">
            <div className='loadingSimulacao' >
            {isShow && <Loading />}
            </div>
            <EtapaSimulacao />
            <BannerSimulacaoPhone />
            
            <form
                className={exibirPagina? "container2": "container2 hidePage" }
                onSubmit={handleSubmit}
            >
                
                <Input id="valorSimulacao" name="valorSimulacao" type="hidden" value={valor} />
                <Input id="parcelaSimulacao" name="parcelaSimulacao" type="hidden" value={prazo} />

                <div className='form'>
                    <div className='titleformSimulacao'>
                        <h4>Você tem crédito pré-aprovado com a gente!</h4>
                    </div>
                    <div className='spaceform'></div>
                    <div className='Input-form'>
                        <h1 className='selecioneOpcao'>Selecione uma das opções abaixo:</h1>
                    
                        <div className={melhorOpcao} onClick={choicePropos}>
                            <div className={melhorOpcao2}></div>
                            <div className='tit'>{valorTotalProposta.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})} </div>
                            <div className='desc'>{valor.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})} em {prazo} vezes</div>
                        </div>

                        <div className='melhorOpcao'>Essa é a melhor proposta que encontramos para você!</div>

                        <div className='outrasPropostas' onClick={showProposta}>
                            <div className={circulo}></div>
                            <div className={btnOpcao}>Outras opções</div>
                        </div>

                        <div className='selecioneValor'>
                            {isOpen && <OutrasOpcoes propostas={{outrasPropostas, valorTotalProposta}} />}
                        </div>

                        <div className='spaceform'></div>

                        <Button
                            message='CONTINUAR'
                            className={btnContinuar}
                            isChecked={isChecked}
                        />
                        
                        <button
                            className={btnVoltar}
                            cursor='pointer'
                            onClick={() => navigate("/endereco")}>
                            VOLTAR
                        </button>
            
                    </div>
                </div>
            </form>
        </div>
    );
}

export default Simulacao;